import { Input } from "@/components/ui/input";
import FormField from "./FormField";

const PricingAndLocationFields = ({
  formData,
  handleInputChange,
  errors,
  isSubmitting
}) => {
  return (
    <>
      <FormField id="price" label="Price ($)" error={errors.price}>
        <Input
          id="price"
          name="price"
          type="number"
          placeholder="e.g., 99.99"
          value={formData.price}
          onChange={handleInputChange}
          min="0.01"
          step="0.01"
          disabled={isSubmitting}
        />
      </FormField>

      <FormField id="quantity" label="Quantity" error={errors.quantity}>
        <Input
          id="quantity"
          name="quantity"
          type="number"
          placeholder="1"
          value={formData.quantity}
          onChange={handleInputChange}
          min="1"
          step="1"
          disabled={isSubmitting}
        />
      </FormField>

      <FormField
        id="postalCode"
        label="Your ZIP Code (Location of Part)"
        error={errors.postalCode}
        description="Used to help buyers find parts locally."
      >
        <Input
          id="postalCode"
          name="postalCode"
          placeholder="e.g., 90210"
          value={formData.postalCode}
          onChange={handleInputChange}
          maxLength={5}
          disabled={isSubmitting}
        />
      </FormField>
    </>
  );
};

export default PricingAndLocationFields;
